import ClaimingStatus from '../types/claimingStatus';
import config from '../constants/config';
import { useContractRead } from 'wagmi';

const useClaimingStatusV2 = (): [
  status: ClaimingStatus,
  readStatus: () => void
] => {
  const { data, refetch } = useContractRead({
    addressOrName: config.contracts.fancyBearStakingRewardContractV2.address,
    contractInterface:
      config.contracts.fancyBearStakingRewardContractV2.interface,
    functionName: 'claimingStatus',
  });

  return [data as any as ClaimingStatus, refetch];
};

export default useClaimingStatusV2;
